import { CircleTimes, SyncIcon } from 'components/Icons';
import LayoutContext from 'components/Layout/LayoutContext';
import Breadcrumb, {
  IBreadCrumbItem,
} from 'components/__ASSESSOR__/BreadCrumb/BreadCrumb';
import NucleoButton from 'components/__SHARED__/nucleoButton/nucleoButton';
import Page from 'components/__SHARED__/PrivateContainer';
import { ConferirNucleoOptions } from 'helpers/enums/VerificarVotoEnum';
import { getUniqueKey } from 'helpers/utils/KeyUtils';
import { AssembleiaAssessorRoutePath, AssessorRoutePath } from 'library/Routes';
import translation from 'locales/translation';
import {
  Button,
  ButtonThemes,
  Checkbox,
  CheckIcon,
  Col,
  Collapse,
  ConfirmModal,
  ControlLabel,
  ModalSizes,
  Paginator,
  Row,
  Select,
  Table,
  Title,
  ToastTypes,
} from 'plataforma-fundacao-componentes';
import {
  Fragment,
  useCallback,
  useContext,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { closeModal, openModal } from 'store/modules/ModalActions';
import { IReducer } from 'store/Reducer';
import { history } from 'store/Store';
import Context from '../../Context';
import useVerificarInconsistencia from './useVerificarInconsistencia';
import style from './VerificarInconsistencia.scss';
const { rootClassName } = style;

export default function VerificarInconsistencia() {
  const { evento, loadingEvento } = useContext(Context);
  const { pautas } = useSelector((state: IReducer) => state.assessor);
  const params = useParams() as { id?: string; idPauta?: string };
  const dispatch = useDispatch();

  const { showToast } = useContext(LayoutContext);

  const breadcrumb = useMemo(
    (): IBreadCrumbItem[] => [
      { nome: translation.MainRoute.title, url: AssessorRoutePath },
      {
        nome: loadingEvento
          ? translation.AssembleiaAssessorRoute.carregando
          : evento?.nome!,
        url: `${AssembleiaAssessorRoutePath.replace(
          ':id',
          String(evento?.id)
        )}`,
      },
      { nome: translation.VerificarInconsistencia.title },
    ],
    [loadingEvento, evento]
  );

  const pauta = useMemo(() => {
    const pauta = pautas?.elements.find(
      (p) => p.idPauta === parseInt(params.idPauta!)
    );
    return pauta;
  }, [params, pautas]);

  const [selectValue, setValue, loading, lines, alterarVotosNucleos] =
    useVerificarInconsistencia(evento!?.id, pauta!?.idPauta);

  const valorMaximo = useMemo(() => {
    return lines?.reduce((soma, agenciaAtual) => {
      return soma + agenciaAtual!?.nucleos!?.length;
    }, 0);
  }, [lines]);

  const [selecionados, setSelecionados] = useState<string[]>([]);

  const isTodosSelecionados = useMemo(() => {
    return selecionados.length === valorMaximo;
  }, [selecionados, valorMaximo]);

  const [opcaoDeVoto, setOpcaoDeVoto] = useState<number | undefined | null>(
    null
  );
  const [loadingVoto, setLoadingVoto] = useState(false);
  const [loadingAusencia, setLoadingAusencia] = useState(false);

  useLayoutEffect(() => {
    setSelecionados([]);
  }, [lines]);

  const mkeyRef = useRef<string | undefined>();
  const openConfirmModal = useCallback(
    (title: string, children: any, onConfirm: () => any) => {
      mkeyRef.current = `alert${getUniqueKey()}`;
      dispatch(
        openModal(ConfirmModal, {
          preventMaskExit: true,
          size: ModalSizes.Small,
          modalKey: mkeyRef.current,
          title,
          children,
          onConfirm,
          onCancel: () => dispatch(closeModal(mkeyRef.current)),
          onClose: () => dispatch(closeModal(mkeyRef.current)),
        })
      );
    },
    [dispatch]
  );

  return (
    <Page
      header={
        <Fragment>
          <Col>
            <Title
              showBackButton
              onBackClick={() => {
                history.push(
                  `${AssembleiaAssessorRoutePath.replace(
                    ':id',
                    String(evento?.id)
                  )}`
                );
              }}
            >
              {translation.VerificarInconsistencia.title}
            </Title>
          </Col>
          <Col>
            <Breadcrumb itens={breadcrumb} />
          </Col>
        </Fragment>
      }
    >
      <div className={rootClassName}>
        <Collapse opened={Boolean(pauta!?.titulo)}>
          <Row>
            <Col>
              <div className={`${rootClassName}-nome-pauta`}>
                {pauta!?.titulo}
              </div>
            </Col>
          </Row>
        </Collapse>
        <Row>
          <Col className={`${rootClassName}-subtitle`}>
            {translation.VerificarInconsistencia.subtitle}
          </Col>
        </Row>
        <Row>
          <Col>
            <Select
              value={selectValue}
              onChange={(newValue: ConferirNucleoOptions) => {
                setValue(newValue);
                setOpcaoDeVoto(null);
              }}
              label={translation.VerificarInconsistencia.filterLabel}
              placeholder={
                translation.VerificarInconsistencia.filterPlaceholder
              }
              options={[
                {
                  label: String(
                    translation.VerificarInconsistencia[
                      `${ConferirNucleoOptions.NucleosPresentes}`
                    ] || ''
                  ),
                  value: ConferirNucleoOptions.NucleosPresentes,
                },
                {
                  label: String(
                    translation.VerificarInconsistencia[
                      `${ConferirNucleoOptions.NucleosAusentes}`
                    ] || ''
                  ),
                  value: ConferirNucleoOptions.NucleosAusentes,
                },
              ]}
            />
          </Col>
        </Row>
        {lines && lines.length ? (
          <Row>
            <Col>
              <Table
                columns={[
                  {
                    key: 'checkbox',
                    value: (
                      <div>
                        <Checkbox
                          value={isTodosSelecionados}
                          onChange={(val) => {
                            if (val) {
                              setSelecionados(
                                lines.reduce<string[]>(
                                  (arr, atual) => [
                                    ...arr,
                                    ...atual.nucleos.map(
                                      (n) =>
                                        `${atual.codigoAgencia}-${n.numeroNucleo}`
                                    ),
                                  ],
                                  []
                                )
                              );
                            } else {
                              setSelecionados([]);
                            }
                          }}
                        />
                      </div>
                    ),
                    props: { style: { width: '50px' }, align: 'center' },
                  },
                  {
                    key: 'agencia',
                    value: translation.VerificarInconsistencia.Agencia,
                    props: { style: { width: '90px' }, align: 'center' },
                  },
                  {
                    key: 'nucleos',
                    value: translation.VerificarInconsistencia.Nucleos,
                    props: {
                      align: 'left',
                    },
                  },
                ]}
                lines={lines.map((l) => {
                  return {
                    checkbox: (
                      <Fragment>
                        <Checkbox
                          value={l.nucleos.every((n) => {
                            return selecionados!?.includes(
                              `${l.codigoAgencia}-${n.numeroNucleo}`
                            );
                          })}
                          onChange={(val) => {
                            if (val) {
                              setSelecionados(
                                selecionados
                                  .filter(
                                    (s) => !s.startsWith(`${l.codigoAgencia}-`)
                                  )
                                  .concat(
                                    l.nucleos.map(
                                      (n) =>
                                        `${l.codigoAgencia}-${n.numeroNucleo}`
                                    )
                                  )
                              );
                            } else {
                              setSelecionados(
                                selecionados.filter(
                                  (s) => !s.startsWith(`${l.codigoAgencia}-`)
                                )
                              );
                            }
                          }}
                        />
                      </Fragment>
                    ),
                    agencia: l.codigoAgencia,
                    nucleos: (
                      <div className={`${rootClassName}-nucleos-cell`}>
                        {l.nucleos.map((n) => {
                          return (
                            <NucleoButton
                              key={`${l.codigoAgencia}-${n.numeroNucleo}`}
                              value={selecionados!?.includes(
                                `${l.codigoAgencia}-${n.numeroNucleo}`
                              )}
                              label={n.numeroNucleo}
                              tooltipLabel={
                                n.representante!
                                  ? `${translation.VerificarInconsistencia.tooltipPrefix}: ${n.representante}`
                                  : undefined
                              }
                              onChange={(val) => {
                                if (val) {
                                  setSelecionados(
                                    selecionados.concat(
                                      `${l.codigoAgencia}-${n.numeroNucleo}`
                                    )
                                  );
                                } else {
                                  setSelecionados(
                                    selecionados.filter(
                                      (s) =>
                                        s !==
                                        `${l.codigoAgencia}-${n.numeroNucleo}`
                                    )
                                  );
                                }
                              }}
                            />
                          );
                        })}
                      </div>
                    ),
                  };
                })}
              />
            </Col>
          </Row>
        ) : undefined}
        {loading ? (
          <Row>
            <Col>
              <Paginator
                loading
                paginaAtual={0}
                quantidadeDePaginas={0}
                onChange={() => {}}
              />
            </Col>
          </Row>
        ) : undefined}
        {!loading && !lines?.length && selectValue ? (
          <Row>
            <Col centralized>
              {translation.VerificarInconsistencia.toasts.semNucleos}
            </Col>
          </Row>
        ) : undefined}
        {selectValue && lines && lines.length && !loading ? (
          <Row>
            {selectValue === ConferirNucleoOptions.NucleosPresentes ? (
              <Col>
                <ControlLabel
                  label='Sem manifestação de voto'
                  control={
                    <Checkbox
                      value={opcaoDeVoto === undefined}
                      onChange={(e) => {
                        setOpcaoDeVoto(e ? undefined : null);
                      }}
                    />
                  }
                />
              </Col>
            ) : (
              <Fragment />
            )}

            <Col>
              <Select
                value={opcaoDeVoto}
                onChange={(evt) => setOpcaoDeVoto(evt)}
                disabled={opcaoDeVoto === undefined}
                options={[
                  ...pauta!.itens.map((item) => {
                    return {
                      label: item.descricao,
                      value: item.idItemPauta,
                    };
                  }),
                ]}
                placeholder={
                  translation.VerificarInconsistencia.opcaoDeVoto.placeholder
                }
                label={translation.VerificarInconsistencia.opcaoDeVoto.label}
              />
            </Col>
          </Row>
        ) : undefined}
        {selectValue && lines && lines.length ? (
          <Row>
            <Col className={`${rootClassName}-actions-col`} end noPadding>
              <Button
                theme={ButtonThemes.Secondary}
                disabled={loadingVoto}
                leftIcon={<CircleTimes />}
                onClick={() => {
                  setValue(undefined);
                  setOpcaoDeVoto(undefined);
                }}
              >
                {translation.VerificarInconsistencia.buttons.cancel}
              </Button>

              {opcaoDeVoto === undefined ? (
                <Button
                  theme={ButtonThemes.Primary}
                  disabled={!selecionados.length || opcaoDeVoto !== undefined}
                  leftIcon={loadingVoto ? <SyncIcon animated /> : <CheckIcon />}
                  onClick={() => {
                    openConfirmModal(
                      translation.VerificarInconsistencia.buttons.confirm,
                      translation.VerificarInconsistencia.modals.confirmarVoto(
                        pauta!?.itens!?.find(
                          (p) => p.idItemPauta === opcaoDeVoto
                        )!?.descricao
                      ),
                      () => {
                        setLoadingVoto(true);
                        return alterarVotosNucleos(
                          selecionados,
                          opcaoDeVoto === undefined ? null : opcaoDeVoto!,
                          false
                        )
                          .then(() => {
                            setOpcaoDeVoto(undefined);
                            toast.success(
                              translation.VerificarInconsistencia.toasts
                                .sucessoAoConfirmar
                            );
                          })
                          .catch(() => {
                            showToast({
                              pauseOnFocusLoss: true,
                              theme: ToastTypes.Error,
                              showStatusBar: true,
                              timeout: 4000,
                              label:
                                translation.VerificarInconsistencia.toasts
                                  .erroAoConfirmar,
                            });
                          })
                          .finally(() => {
                            dispatch(closeModal(mkeyRef.current));
                            setLoadingVoto(false);
                          });
                      }
                    );
                  }}
                >
                  Confirmar
                </Button>
              ) : (
                <Fragment>
                  {selectValue === ConferirNucleoOptions.NucleosAusentes &&
                  !loading ? (
                    <Button
                      theme={ButtonThemes.Danger}
                      disabled={
                        !selecionados!?.length ||
                        loadingAusencia ||
                        Boolean(opcaoDeVoto)
                      }
                      leftIcon={
                        loadingAusencia ? <SyncIcon animated /> : <CheckIcon />
                      }
                      onClick={() => {
                        setOpcaoDeVoto(null);
                        openConfirmModal(
                          translation.VerificarInconsistencia.buttons
                            .confirmarAusencia,
                          translation.VerificarInconsistencia.modals
                            .confirmarAusencia,
                          () => {
                            setLoadingAusencia(true);
                            return alterarVotosNucleos(
                              selecionados,
                              opcaoDeVoto!,
                              true
                            )
                              .then(() => {
                                setOpcaoDeVoto(null);
                                toast.success(
                                  translation.VerificarInconsistencia.toasts
                                    .sucessoAusencia
                                );
                              })
                              .catch(() => {
                                showToast({
                                  pauseOnFocusLoss: true,
                                  theme: ToastTypes.Error,
                                  showStatusBar: true,
                                  timeout: 4000,
                                  label:
                                    translation.VerificarInconsistencia.toasts
                                      .erroAusencia,
                                });
                              })
                              .finally(() => {
                                dispatch(closeModal(mkeyRef.current));
                                setLoadingAusencia(false);
                              });
                          }
                        );
                      }}
                    >
                      {
                        translation.VerificarInconsistencia.buttons
                          .confirmarAusencia
                      }
                    </Button>
                  ) : undefined}
                  <Button
                    theme={ButtonThemes.Primary}
                    disabled={
                      !selecionados.length ||
                      !Boolean(opcaoDeVoto) ||
                      loadingVoto
                    }
                    leftIcon={
                      loadingVoto ? <SyncIcon animated /> : <CheckIcon />
                    }
                    onClick={() => {
                      openConfirmModal(
                        translation.VerificarInconsistencia.buttons.confirm,
                        translation.VerificarInconsistencia.modals.confirmarVoto(
                          pauta!?.itens!?.find(
                            (p) => p.idItemPauta === opcaoDeVoto
                          )!?.descricao
                        ),
                        () => {
                          setLoadingVoto(true);
                          return alterarVotosNucleos(
                            selecionados,
                            opcaoDeVoto === undefined ? null : opcaoDeVoto!,
                            false
                          )
                            .then(() => {
                              setOpcaoDeVoto(null);
                              toast.success(
                                translation.VerificarInconsistencia.toasts
                                  .sucessoAoConfirmar
                              );
                            })
                            .catch(() => {
                              showToast({
                                pauseOnFocusLoss: true,
                                theme: ToastTypes.Error,
                                showStatusBar: true,
                                timeout: 4000,
                                label:
                                  translation.VerificarInconsistencia.toasts
                                    .erroAoConfirmar,
                              });
                            })
                            .finally(() => {
                              dispatch(closeModal(mkeyRef.current));
                              setLoadingVoto(false);
                            });
                        }
                      );
                    }}
                  >
                    {translation.VerificarInconsistencia.buttons.confirm}
                  </Button>
                </Fragment>
              )}
            </Col>
          </Row>
        ) : undefined}
      </div>
    </Page>
  );
}
